import React, { useMemo } from 'react';
import EmpresaBannerSlot from 'frontend/features/banners/components/EmpresaBannerSlot';
import commons from 'legacyfrontend/components/commons';
import useBannerNavigation from 'legacyfrontend/hooks/useBannerNavigation';
import { useAmenitiesIcons } from 'legacyfrontend/hooks/packages';
import { isV1Banner } from 'frontend/features/banners';

const BannerHover = ({ data }) => {
  const { getNavigationProps } = useBannerNavigation();
  const [getIcon] = useAmenitiesIcons();
  const { 
    title, 
    imageUrl, 
    imagenMobile,
    description, 
    price,
    manualPrice,
    services,
    tag,
    descuento,
    mostrarTitulo, 
    mostrarDescripcion,
    mostrarPrecio,
    mostrarDescuento,
    mostrarExtra
  } = data;
  const navigationProps = getNavigationProps(data);
  const desktopImg = commons.imgUrlValidator(imageUrl);
  const mobileImg = commons.imgUrlValidator(imagenMobile || imageUrl);

  const biyu = price === null ? manualPrice : price;

  const renderAmenitiesIcons =
    services &&
    services.map((serviceKeyName) => (
      <span key={`${title}-service-${serviceKeyName}`} className='mr-2'>
        <i className={getIcon(serviceKeyName)} />
      </span>
    ));

  const hasTextContent = (!mostrarTitulo && title) || (!mostrarDescripcion && description);
  const hasPriceContent = !mostrarPrecio && biyu;
  const hasAmenitiesContent = !mostrarExtra && renderAmenitiesIcons;
  const hasTagContent = (!mostrarExtra && tag?.trim()) || 
                       (!mostrarPrecio && manualPrice?.trim()) || 
                       (!mostrarDescuento && descuento?.trim());
  
  const hasContent = hasTextContent || hasPriceContent || hasAmenitiesContent || hasTagContent;

  return [
    <div className='hoverx4-container shadow-xl group bg-black' key={title}>
      <div className='hoverx4_ContainerImg'>
        <picture>
          <source media='(max-width: 768px)' srcSet={mobileImg} />
          <img
            className='hoverx4_img opacity-100 group-hover:opacity-70 transition duration-600'
            src={desktopImg}
            alt={commons.filterText(title)}
          />
        </picture>
        {hasTagContent && (
          <div className='banner_tag-amenities'>
            {!mostrarExtra && tag?.trim() && (
              <div className='banner_tag'>{tag}</div>
            )}
            {!mostrarPrecio && manualPrice?.trim() && (
              <div className='banner_tag_price'>{manualPrice}</div>
            )}
            {!mostrarDescuento && descuento?.trim() && (
              <div className='banner_discount'>{descuento}</div>
            )}
          </div>
        )}
        <div className='hoverx4_ContainerTitle'>
          {!mostrarTitulo && <div className='hoverx4_title text-white text-3xl p-3'>{title}</div>}
        </div>
      </div>

      <div className='hoverx4_back transition delay-200 duration-600 opacity-0 group-hover:opacity-100'>
        <div className='height_details'>
          {!mostrarDescripcion && description && (
            <div className='p-6 text-2xl text-white'>{description}</div>
          )}
          {hasPriceContent && (
            <div className='p-6 text-xl text-white'>
              <span className='price-text'>{biyu}</span>
            </div>
          )}
          {hasAmenitiesContent && (
            <div className='p-6 text-white'>{renderAmenitiesIcons}</div>
          )}
        </div>
        <button
          className={`moreInfo ${mostrarTitulo ? 'mt-24' : ''} ${mostrarDescripcion ? 'mt-24' : ''}`}
          type='button'
        >
          <a
            href={navigationProps.href}
            target={navigationProps.target}
            rel='noreferrer'
            className='text-white'
          >
            + INFO
          </a>
        </button>
      </div>
    </div>,
  ];
};

const BannerHoverV1 = ({ data }) => (
  <div className='hoverx4-container shadow-xl group bg-black' key={data.id}>
    <EmpresaBannerSlot data={data} hoverOverlay templateOverride={2} />
  </div>
);

export default function BannerHoverx4({ data }) {
  const { banner, categoria } = data;
  const bannerListLength = (banner && banner.length) || 0;

  const renderHover = useMemo(() => {
    let hoverList = [];

    for (let count = 0; count < bannerListLength && count <= 3; count++) {
      const item = banner[count];
      hoverList = hoverList.concat([
        isV1Banner(item) ? (
          <BannerHoverV1 key={item.id} data={item} />
        ) : (
          <BannerHover key={item.id} data={item} />
        ),
      ]);
    }

    return hoverList;
  }, [banner, bannerListLength]);

  return (
    <div className='container mb-8 md:mb-12'>
      <h3 className='feauteredSevenTwenty-title mb-3 text-gray-600'>{categoria.descripcion}</h3>
      <div className='flex flex-wrap gap-5 justify-center'>
        {[...renderHover].sort((a, b) => a.props.data.orden - b.props.data.orden)}
      </div>
    </div>
  );
}
